/* eslint-disable react/jsx-props-no-spreading */
import { Suspense } from 'react';
import { Route, Redirect } from 'react-router-dom';

import { ROUTE_DASHBOARD_REWARDS } from '../../../config/routes';
import { useFirebaseAuth } from '../../../../global/FirebaseProvider/FirebaseProvider';
import Loading from '../../Loading';

const PublicRoute = ({
  component: Component,
  handleRedirect = true,
  render: customRender,
  ...rest
}) => {
  const { isSignedIn } = useFirebaseAuth();

  return (
    <Route
      {...rest}
      render={(props) => (
        <Suspense fallback={<Loading />}>
          {customRender
            ? customRender(props.location)
            : (handleRedirect && isSignedIn && (
              <Redirect to={ROUTE_DASHBOARD_REWARDS} />
            )) || <Component {...props} />}
        </Suspense>
      )}
    />
  );
};

export default PublicRoute;
